var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _c(
        "DefaultContentLayout",
        {
          scopedSlots: _vm._u([
            {
              key: "right-side",
              fn: function () {
                return [
                  _c("CustomRequestFilters", {
                    attrs: {
                      currentUserId: _vm.currentUser.id,
                      isAdmin: _vm.isAdmin,
                    },
                    on: {
                      filtersChanged: _vm.updateFilters,
                      resetFilters: _vm.resetFilters,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "LoadingOverlay",
            {
              attrs: {
                hasData: !!_vm.requests,
                loading: _vm.$apollo.loading,
                spinnerCentered: "",
              },
            },
            [
              _vm.showEmptyListPlaceholder
                ? _c(
                    "EmptyListPlaceholder",
                    {
                      attrs: { title: _vm.emptyListSubtitle },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "image",
                            fn: function () {
                              return [_c("EmptyListImageRequests")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2557147869
                      ),
                    },
                    [
                      !_vm.isAdmin
                        ? _c("UIButton", {
                            attrs: {
                              buttonText: "External Sourcing Request",
                              size: "xl",
                            },
                            on: { click: _vm.toggleRequestModal },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "icon",
                                  fn: function () {
                                    return [
                                      _c("PlusIcon", {
                                        staticClass:
                                          "text-white fill-current w-2.5 h-2.5",
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2391170647
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : [
                    _c(
                      "ActionPanel",
                      {
                        staticClass: "mb-4",
                        attrs: { total: _vm.paginationConfig.total },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex" },
                          [
                            !_vm.isAdmin
                              ? _c("UIButton", {
                                  staticClass: "ml-auto",
                                  attrs: {
                                    buttonText: "External Sourcing Request",
                                  },
                                  on: { click: _vm.toggleRequestModal },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "icon",
                                        fn: function () {
                                          return [
                                            _c("PlusIcon", {
                                              staticClass:
                                                "text-white fill-current w-2.5 h-2.5",
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2391170647
                                  ),
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-2 gap-4" },
                      _vm._l(_vm.requests, function (request) {
                        return _c("RequestCard", {
                          key: request.id,
                          attrs: {
                            request: request,
                            skills: request.skills,
                            createdBy: request.created_by,
                            currentUserId: _vm.currentUser.id,
                            isAdmin: _vm.isAdmin,
                            companyId: _vm.company.id,
                          },
                          on: { refetch: _vm.handleRefetch },
                        })
                      }),
                      1
                    ),
                    _c("CardPagination", {
                      attrs: { config: _vm.paginationConfig },
                      on: {
                        "update:config": function ($event) {
                          _vm.paginationConfig = $event
                        },
                      },
                    }),
                  ],
              _vm.dialog
                ? _c("CustomRequestModal", {
                    attrs: {
                      currentUserId: _vm.currentUser.id,
                      companyId: _vm.company.id,
                      isAdmin: _vm.isAdmin,
                    },
                    on: {
                      close: _vm.toggleRequestModal,
                      refetch: _vm.handleRefetch,
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }